export default __webpack_public_path__ + "static/media/img_helix_0.2a110803.png";